import React, { Component } from "react";
import api from "../../store/services/api";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import ModalHeader from "./modalHeader";
import Divider from "@mui/material/Divider";
import { orderCancelReasonsFrame } from "../../common/frames";
import Typography from "@mui/material/Typography";
import { LightGreyBox } from "../styled";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

export default class RequestCancel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      order: this.props.order,
      code: "",
      reason: "",
      cancellationReasons: [],
      noReasonsAvailable: false,
    };
  }

  loadData = async () => {
    try {
      let options = [];
      if (
        this.props.order.channel === "IFOOD" ||
        this.props.order.channel === "FOOD99"
      ) {
        // 99Food publishes a fixed reason_id list rather than per-order options, and
        // rejects the self-delivery-only reasons on orders its own fleet is carrying —
        // the backend filters those out, so both channels are just "ask the API".
        const path =
          this.props.order.channel === "FOOD99"
            ? "/food99/cancel-codes/"
            : "/iFood/cancel-codes";
        const res = await api.get(
          `${path}?oid=${this.props.order.channel_order_id}`
        );

        if (res.status === 204) {
          this.setState({ noReasonsAvailable: true });
        } else {
          options = res.data.map((reason) => {
            return {
              value: reason.cancelCodeId,
              label: reason.description,
            };
          });

          this.setState({
            cancellationReasons: options,
            noReasonsAvailable: false,
          });
        }
      } else {
        orderCancelReasonsFrame.forEach((reason) => {
          const option = {
            value: reason.cancelCodeId,
            label: reason.description,
          };
          options.push(option);
        });

        this.setState({
          cancellationReasons: options,
          noReasonsAvailable: false,
        });
      }
    } catch (err) {
      console.log(err);
      this.setState({ noReasonsAvailable: true });
    }
  };

  componentDidMount = () => this.loadData();

  changeCancelCode = (event, value) => {
    this.setState({
      code: value ? value.value : "",
      reason: value ? value.label : "",
    });
  };

  changeCancelReason = (event) => {
    const value = event.target.value;
    this.setState({
      reason: value,
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.state.reason.length > 5) {
      this.props.submitCancel(this.state.code, this.state.reason);
    } else {
      alert("Informe o motivo. Mínimo de 5 caracteres");
    }
  };

  closeModal = () => {
    this.props.closeModal();
  };

  render() {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={this.props.show}
        onClose={this.closeModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        sx={{ zIndex: 9999 }}
      >
        <Fade in={this.props.show}>
          <Box sx={style}>
            <ModalHeader
              label={`Cancelar pedido ${this.state.order.order_index}`}
              margin={0}
              onClose={this.closeModal}
              dividerText={`${this.state.order.channel} - ${this.state.order.channel_order_code}`}
            />
            {this.state.noReasonsAvailable ? (
              <LightGreyBox marginBottom={2}>
                <Typography variant="body2" color="red" textAlign="center">
                  O iFood já não permite o cancelamento desse pedido
                </Typography>
              </LightGreyBox>
            ) : (
              <>
                <Autocomplete
                  disablePortal
                  id="cancel-reason"
                  options={this.state.cancellationReasons}
                  renderInput={(params) => (
                    <TextField {...params} label="Motivo" />
                  )}
                  onChange={this.changeCancelCode}
                  sx={{ mt: 2 }}
                />
                <Divider sx={{ my: 2 }} />
                <TextField
                  id="cancel-description"
                  label="Descrição"
                  multiline
                  rows={4}
                  value={this.state.reason}
                  style={{ width: "100%" }}
                  onChange={this.changeCancelReason}
                />
                <Divider sx={{ m: 4 }} />
              </>
            )}
            <Button
              fullWidth
              type="submit"
              variant="contained"
              color="error"
              size="large"
              sx={{ boxShadow: "none", textTransform: "none" }}
              onClick={this.handleSubmit}
              disabled={this.state.noReasonsAvailable}
            >
              Cancelar
            </Button>
          </Box>
        </Fade>
      </Modal>
    );
  }
}
